import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'pim-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    standalone: false
})
export class AppComponent implements OnInit {
	mainLayout: boolean = true;
	showSideNav: boolean = true;

	constructor(private router: Router, private authService: AuthenticationService) {
		this.initRouteListener();
	}

	ngOnInit(): void {
		this.initAuthentication();
	}

	toggleSideNav(): void {
		this.showSideNav = !this.showSideNav;
	}

	private initAuthentication(): void {
		this.authService.init();
	}

	private initRouteListener(): void {
		this.router.events.pipe(
			// tslint:disable-next-line:typedef
			filter((routerEvent): routerEvent is NavigationEnd => {
				return routerEvent instanceof NavigationEnd;
			})
		).subscribe((event: NavigationEnd) => {
				this.mainLayout = event.url.indexOf('no-permission') === -1;
			}
		);
	}

}
